export const UPDATE_AUTH_INFO = "UPDATE_AUTH_INFO";
export const SET_USER_WORKSPACES = "SET_USER_WORKSPACES";
export const UPDATE_PARTICULAR_WORKSPACE = "UPDATE_PARTICULAR_WORKSPACE";
